import { Component, ComponentRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlertsvarService } from 'src/app/alerts/alertsvar.service';
import { AlertsService } from 'src/app/alerts/alerts-custom.service';
import { FormArray, UntypedFormGroup } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';
import { QueryEditorService } from 'src/app/language-service/query-editor.service';
import { RoutecrumpsService } from 'src/app/services/routecrumps.service';
import { StructureTagService } from 'src/app/services/structureTag.service';
import { QueryTokensProviderService } from 'src/app/language-service/query-tokens-provider.service';
import { ToastService } from '../custom-overlay/toast/toast.service';
import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ExplorelogsService } from 'src/app/explore-logs/explorelogs.service';
import { AbstractControl } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';
// import { settings } from 'cluster';
import { CdkDragDrop, moveItemInArray, CdkDrag } from '@angular/cdk/drag-drop';
import { SharedService } from 'src/app/services/shared.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { RulevarService } from 'src/app/rule/rulevar.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { DatePipe } from '@angular/common';
import { ViewChildren } from '@angular/core';
import { AutoClosureActionComponent } from '../auto-colosure-condition/auto-closure-action.component';
import { QueryList } from '@angular/core';


@Component({
  selector: 'app-auto-closure-rule',
  templateUrl: './auto-closure-rule.component.html',
  styleUrls: ['./auto-closure-rule.component.scss']
})
export class AutoClosureRuleComponent {
  ruleCOnditions: any = {};
  platform_plugins: object;
  constructor(public router: Router,
    public alertvarservice: AlertsvarService,
    public alertservice: AlertsService,
    public queryEditorService: QueryEditorService,
    private rcrumpService: RoutecrumpsService,
    private sharedService: SharedService,
    private toasterService: ToastService,
    private timezoneservice:TimeZoneService,
    private datePipe: DatePipe,
    public querytokensprovider: QueryTokensProviderService) {
  }

  // selfRef!: ComponentRef<AutoInvestigateRuleComponent>;

  alertId;
  form: FormGroup = new FormGroup({
    closureAction: new FormControl('')
  });
  selectedIndex = 0;
  description: string = ''
  platform: string = ''
  ruleType: string = ''
  alertName: string = ''
  mat_spinner_create_state: boolean = false;
  routeBack: Subject<null> = new Subject();
  $destroy: Subject<boolean> = new Subject();
  destroyed$: Subject<boolean> = new Subject();
  queryCheck = ["1"]
  current_index = 0
  previous_index = 0
  // timeEmit:any
  // stepEmit:any
  timeframevalue: any = 3600
  stepsizevalue: any = 3600
  valuerange: any
  min: number
  max: number
  step: any[]
  errstr = ''
  spinner_state: boolean = false
  lables = {
    tabTitle: { 0: "1. Context", 1: "2. Condition & Action" },
    iconTitle: { "up": "Move Up", "down": "Move Down" }
  }

  validForData=JSON.parse(JSON.stringify(this.alertvarservice.validForData))

  currentdate = this.timezoneservice.getcurrentuserTime().format('YYYY-MM-DD HH:mm:ss');

  modifiedDate:any

  unique =new Set()

  @ViewChildren(AutoClosureActionComponent) children: QueryList<AutoClosureActionComponent>



  async ngOnInit() {
    // console.log(this.alertvarservice._alertName.getValue())

    if(this.alertvarservice.editState){
      this.will_expire.setValue(this.alertvarservice.editrequested.value.will_expire? this.alertvarservice.editrequested.value.will_expire : false)
    }
    const date = new Date(this.currentdate);
    date.setDate(date.getDate() + 1);
//console.log({date})
    this.modifiedDate=this.convertDate(date.toString())
    
   
    
    // console.log(this.modifiedDate)
    // console.log(this.currentdate)
    // console.log(this.timezoneservice.getcurrentuserTime())
    // console.log(this.alertvarservice.ruleCOnditions)

    await this.alertvarservice.$alert.pipe(takeUntil(this.$destroy)).subscribe(value => {
      
//console.log({value})
      this.ruleCOnditions = value
      this.setLanguageGrammar(value["platform"], value["alertId"])
    })
    // console.log("RuleConditions->",this.ruleCOnditions)

    if (this.alertvarservice.editState) {
      this.rcrumpService.route_crumps[2] = {
        disp_str: "Edit",
        routeTo: "rule/auto-closure-rule",
        callback: null,
        isParent: false
      }
    }
    else {
      this.rcrumpService.route_crumps[2] = {
        disp_str: "Auto Closure",
        routeTo: "alerts/auto-closure-rule",
        callback: this.routeBack,
        isParent: false
      }
    }
    this.routeBack.subscribe(() => {
      // this.selfRef.destroy();
      this.crumpsBackClick()
    })


    if (this.alertvarservice.editState) {

      setTimeout(() => {
        this.timeframe.setValue(this.ruleCOnditions.timeframe)

      }, 100);
      setTimeout(() => {
        this.stepsize.setValue(this.ruleCOnditions.stepsize)
      }, 200);

      this.alertId = this.ruleCOnditions.ruleFor

    }
    else {
      this.timeframe.setValue(3600)
      this.stepsize.setValue(3600)
    }

    this.alertvarservice.$ruleGroup.subscribe(value => {
      //console.log('ruleType>>>>>>>>>', value);
      this.ruleType = value
      // this.alertservice.alertRules.context.rule_id=this.alertId
    });
    //console.log("Edit State",this.alertvarservice.editState)

    if (this.alertvarservice.editState) {
      this.ruleName.setValue(this.ruleCOnditions.description)

      this.alertId = this.ruleCOnditions.ruleFor
      //console.log("Alert Id",this.alertId)
      this.alertName = this.ruleCOnditions.name
    }
    else {
      this.ruleName.setValue(this.ruleCOnditions.description)
      this.alertvarservice.$alert.subscribe(value => {
        this.alertId = value["alertId"]
        this.platform = value["platform"]
        this.alertName = value["alertTitle"]
      });
    }
    if (this.alertvarservice.editState) {
      this.editset(0)
      setTimeout(() => {
        this.ruleName.setValue(this.ruleCOnditions.description)
      }, 0);

      // console.log("Retro active from ruleConditions =---->", this.ruleCOnditions.retroactive)
      
      this.activate.setValue(this.ruleCOnditions.activate_rule)
      this.retroactive.setValue(this.ruleCOnditions.retroactive)
      // this.retroactive.setValue(true,{emitEvent:true})

      // console.log("Retro active =---->",this.retroactive.value)
      //console.log("Description-->",this.ruleName.value,"\n",this.ruleCOnditions.description)
      
      this.valid_type.setValue("till")
      this.valid_date.setValue(this.alertvarservice.editrequested.value.valid_date)
      // console.log("Edit state")
    }
    else {
      // console.log("New state")
      this.activate.setValue(true)
      this.retroactive.setValue(false)
      this.retro_period.setValue(3600)
      this.valid_for.setValue(864000)
      this.valid_type.setValue("till")
      this.valid_date.setValue(this.modifiedDate)
    }
  }

  convertDate(dateStr: string) {
    return this.datePipe.transform(dateStr, 'yyyy-MM-dd HH:mm:ss');
  }

  ngAfterViewInit() {

    // this.retroactive.valueChanges.subscribe(data=>{
    //   console.log({data})
    // })

    this.will_expire.valueChanges.subscribe(data=>{
//console.log({data})
    })

    this.valid_type.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.$destroy)).subscribe(type=>{
//console.log({type})
    })

    this.timeframe.valueChanges.subscribe((data) => {
//console.log("Will Expire --->",this.will_expire.value)
      // console.log(this.valid_date.value ? this.timezoneservice.toUtcTimeZonefromUser(this.valid_date.value).format('YYYY-MM-DD HH:mm:ss') : "no data")

      this.ruleCOnditions['timeframe'] = data
      //console.log("<---------Timeframe value changes-------->")
      this.timeframevalue = data
      if (this.timeframevalue < this.stepsizevalue) {
        this.errstr = this.alertvarservice.errorType[102]
        // this.rulevarservice.isInvalid=true
        this.alertvarservice.errorState[1] = true;
        this.alertvarservice.timeError = true
        //console.log("ErrorType",this.alertvarservice.errorState[1])
      }
      else {
        this.alertvarservice.errorState[1] = false;
        this.alertvarservice.timeError = false
      }
      this.valuerange = this.alertvarservice.timeframe.find(list => list.value === this.timeframevalue);
      //console.log("Range",this.valuerange?.range[0]); 
      this.min = this.valuerange?.range[0]?.min
      this.max = this.valuerange?.range[0]?.max
      this.step = []
      Object.values(this.alertvarservice.stepsize1).forEach(value => {
        if (value.value >= this.min && value.value <= this.max)
          // console.log(value)
          this.step.push(value)
      });
      this.alertvarservice.stepsize = this.step
      //console.log(this.alertvarservice.stepsize)



    })
    this.stepsize.valueChanges.subscribe((data) => {
      this.ruleCOnditions['stepsize'] = data
      this.stepsizevalue = data


      if (this.timeframevalue < this.stepsizevalue) {
        //console.log("ErrorType",this.alertvarservice.errorState[1])
        //console.log(this.alertvarservice.errorType[102])
        this.errstr = this.alertvarservice.errorType[102]
        // this.rulevarservice.isInvalid=true
        this.alertvarservice.errorState[1] = true;
        this.alertvarservice.timeError = true
        //console.log("ErrorType",this.alertvarservice.errorState[1])
      }
      else {
        this.alertvarservice.errorState[1] = false;
        this.alertvarservice.timeError = false
        this.errstr = ""
      }


    })
    this.ruleName.valueChanges.subscribe((data) => {
      //console.log("Rule Description>>>>>>>>",data)
      this.description = data
      // this.alertservice.alertRules.context.description=data
    })
    this.form.get('closureAction').valueChanges.subscribe(value => {
      //console.log('Value changed in child:',this.selectedIndex,">>>>>>", value);
      //console.log("TokensCheck --------->",this.alertvarservice.autoInvestigate.value.conditions)
      this.conditions.at(this.selectedIndex).patchValue({
        actions: JSON.parse(JSON.stringify(value))
      })
    });
  }

  get context() {
    return this.alertvarservice.ruleForm.get('context') as UntypedFormGroup
  }

  get ruleName() {
    return this.context.get('ruleName')
  }
  get activate() {
    return this.context.get('activate')
  }
  get retroactive() {
    return this.context.get('retroactive')
  }

  get retro_period(){
    return this.context.get('retro_period')
  }

  get valid_for(){
    return this.context.get('valid_for')
  }

  get valid_type(){
    return this.context.get('valid_type')
  }
  get will_expire(){
    return this.context.get('will_expire')
  }

  get valid_date(){
    return this.context.get('valid_date')
  }

  get timeframe() {
    return this.context.get('timeframe')
  }
  get stepsize() {
    return this.context.get('stepsize')
  }

  get conditions() {
    return this.alertvarservice.autoInvestigate.get('conditions') as FormArray

  }
  actions() {
    return this.conditions.get('actions')
  }

  pushForm(i: number) {

    if (this.ruleCOnditions.conditions.length < this.alertvarservice.auto_investigate_limit) {
      this.ruleCOnditions.conditions.splice(i + 1, 0, {
        "actions": {
          "query": "",
          "state": null,
          "action": null,
          "reason": null,
          "isValid":false,
          "tokens": {
            "SearchCommand": []
          },
          "add_tags": {
            "tags": {}
          },
          "comments": "",
          "platform": "firewall_fortigate",
          "condition": "if"
        }
      })
    }
  }

  postSatusChange(status: any) {
    if (status) {
      return 1
    } else {
      return 0
    }
  }

  editset(i: number) {

    let query = ""


    this.alertvarservice.resetRuleForm(), { emitEvent: false }
    this.alertvarservice.resetTags(), { emitEvent: false }
    if (this.alertvarservice.autoInvestigate.value.conditions[i].actions) {

      this.alertvarservice.clickedAction = this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action
      this.alertvarservice.clickedState = this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state
      this.alertvarservice.clickedReason = this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.category
      this.alertvarservice.clickedStateReason = this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason

      if (this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason) {
        this.alertvarservice.openComments = false
        this.alertvarservice.ruleForm.controls.comments.setValue('')
      }
      else {
        this.alertvarservice.openComments = true
      }

      this.alertvarservice.ruleForm.patchValue({
        // query:this.alertvarservice.autoInvestigate.value.conditions[i].actions?.query,
        query: this.ruleCOnditions.conditions[i].actions?.query,
        comments: this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.comments,
        actions: {
          actionname: this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action,
          closurestate: {
            statename: this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state,
            closurereason: this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason
          },
          // comments:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.comments,
          add_tags: this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.add_tags,

        }
      }, { emitEvent: false })
      // console.log("After RuleForm Patch",this.alertvarservice.ruleForm.value.actions.add_tags)
    }
    if (this.alertvarservice.autoInvestigate.value.conditions[i].actions?.state) {
      // this.alertvarservice.closureAction1[this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action].state=1
    }
    //console.log("After Editset RuleForm --->",this.alertvarservice.ruleForm.value)




    // this.queryEditorService.lintChanges$.subscribe(() => {
    //   console.log("Lint Changes Emitted", this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor))
    //   console.log("Editor get",this.queryEditorService.get_editor_value(this.alertvarservice.ruleConditionEditor),this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor))
    //     console.log("Before Set Validation-->",i,this.conditions.get(i.toString()).get("actions"))
    //     this.conditions.get(i.toString()).get("actions")!.setValidators(this.alertvarservice.queryValidator),{emitEvent:false};
    //     this.conditions.get(i.toString()).get("actions")!.updateValueAndValidity({ emitEvent: false });


    //     console.log("Current Index After Validation-->",i,this.conditions.get(i.toString()).get("actions"))
    //     this.alertvarservice.process_state=false
    //     console.log(this.alertvarservice.process_state)
    // })

    // if(this.alertvarservice.autoInvestigate.value.conditions[i].actions){
    //   this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,this.alertvarservice.autoInvestigate.value.conditions[i].actions.query),{emitEvent:false}
    // }
    // else{
    //   this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,query),{emitEvent:false}
    // }
  }

  removeForm(i: number) {
    if (i != 0) {
      // this.conditions.removeAt(i)
      this.ruleCOnditions.conditions.splice(i, 1)
      //console.log("Remove Index--->",i)
      // setTimeout(() => {
      //   this.conditionClick(i)
      // }, 0);

    }
  }


  enableGroupValidation() {
    this.form.get('credentials')!.setValidators(this.alertvarservice.queryValidator);
    this.form.get('credentials')!.updateValueAndValidity({ emitEvent: false });
  }

  disableGroupValidation() {
    this.form.get('credentials')!.clearValidators();
    this.form.get('credentials')!.updateValueAndValidity({ emitEvent: false });
  }




  conditionClick(i: number) {

    this.selectedIndex = i

    let query = ""

  }
  checkAction() {
    //console.log(this.alertvarservice.autoInvestigate)
    if (this.alertvarservice.autoInvestigate.valid) {
      //console.log("Auto Investigate is Valid")
    }
    else {
      //console.log("Auto Investigate is not valid")
    }
  }
  cancelClick = () => {
    this.cancel()


  }
  cancel() {
    if (this.alertvarservice.editState) {
      this.alertvarservice.resetRuleForm()
      this.alertvarservice.resetAutoInvestigate()
      this.router.navigateByUrl('/rule')

    } else {
      this.alertvarservice.resetRuleForm()
      this.alertvarservice.resetAutoInvestigate()
      this.router.navigateByUrl('alerts')
      this.rcrumpService.route_crumps.length = 2;

    }
  }
  crumpsBackClick() {

    this.alertvarservice.resetRuleForm()
    this.alertvarservice.resetAutoInvestigate()
    this.router.navigateByUrl('alerts')
    this.rcrumpService.route_crumps.length = 2;

  }

  engineCheck(rulevalue: any) {
    //console.log(rulevalue.conditions)
    //console.log(this.ruleCOnditions.conditions)
    //  if(!this.alertvarservice.compareobjects(this.ruleCOnditions,rulevalue)){
    //   return true
    //  }else{
    //   return false
    //  }


    if (this.alertvarservice.editrequested.value.retroactive != this.retroactive.value) {
//console.log("Retroactive")
      return true
    }
    if (this.alertvarservice.editrequested.value.timeframe != this.timeframe.value) {
//console.log("Timeframe")
      return true
    }
    if (this.alertvarservice.editrequested.value.stepsize != this.stepsize.value) {
//console.log("stepsize")
      return true
    }
    if (this.alertvarservice.editrequested.value.conditions.length != this.conditions.value.length) {
//console.log("Conditions Length")
      return true
    }
    else {
      //console.log("Compare ArrofObj--->",this.alertvarservice.compareArrayOfObjects(this.ruleCOnditions.conditions,rulevalue.conditions))
      if (!this.alertvarservice.areRuleSetsSame(this.alertvarservice.editrequested.value.conditions, rulevalue.conditions)) {
//console.log("Conditions Check")
        return true
      }
      else {
//console.log("Conditions Check false")
        return false
      }
    }
  }

  async submitClicked() {

//console.log("Post Value",this.ruleCOnditions)
//console.log(this.alertvarservice.autoInvestigate.getRawValue())

    let newPostValue= {"conditions":this.ruleCOnditions.conditions}

    // console.log(this.ruleCOnditions.conditions,"\n")
    // console.log(newPostValue.conditions)


    

    if (!this.alertvarservice.timeError) {
      //   console.log("ErrorState---->False--->",this.alertvarservice.timeError)
      // }
      // else{
      //   console.log("ErrorState---->True--->",this.alertvarservice.timeError)
      // }
      //console.log("VALID",this.alertvarservice.autoInvestigate.controls.conditions.valid)

      Object.keys(this.alertvarservice.autoInvestigate.controls.conditions.controls).forEach((key) => {
        //console.log(key,"Valid",this.alertvarservice.autoInvestigate.controls.conditions.controls[key].controls.actions)
      })

      //console.log("RawValues",this.alertvarservice.autoInvestigate.getRawValue())

      Object.keys(this.alertvarservice.autoInvestigate.getRawValue().conditions).forEach(key => {
        // console.log("raw value",this.alertvarservice.autoInvestigate.getRawValue().conditions[key])
        // if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions?.condition!="else"){
        //   if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions?.state){
        //     this.alertvarservice.actionEmpty=false
        //     this.alertvarservice.showActionError=false
        //     console.log("Not Empty")
        //   }
        //   else{
        //     this.alertvarservice.actionEmpty=true
        //     this.alertvarservice.showActionError=true
        //     console.log("Is Empty")
        //     if(this.alertvarservice.ActionErrorText.length>0){
        //       this.alertvarservice.ActionErrorText=",",[key]
        //     }
        //     else{
        //       this.alertvarservice.ActionErrorText=key
        //     }
        //    }
        //   }
      })

      setTimeout(() => {
        // if (this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor)) {
        //   this.alertvarservice.queryVerified = false
        // }
        // else {
        //   this.alertvarservice.queryVerified = true
        // }
        if (!this.alertvarservice.queryVerified) {
          this.alertvarservice.showError = true
        }
        else {
          this.alertvarservice.showError = false
        }
      }, 500);



      //console.log(this.alertvarservice.autoInvestigate.getRawValue().conditions[0].actions)
      if (this.alertvarservice.autoInvestigate.getRawValue().conditions[0].actions) {
        this.alertvarservice.postError = false
      }
      else {
        this.alertvarservice.postError = true
      }

      let postvalue = this.alertvarservice.autoInvestigate.getRawValue()

      // postvalue.conditions=this.ruleCOnditions.conditions
      //console.log("length",String(postvalue.conditions.length-1))
      Object.keys(postvalue.conditions).forEach(key => {
        //console.log("Key",key)

        //   if(postvalue.conditions[key].actions?.add_tags){
        //     Object.keys(postvalue.conditions[key].actions?.add_tags?.tags).forEach(val=>{
        //       // console.log("Edit Tag",postvalue.conditions[key].actions.add_tags.tags)
        //       if(Object.keys(postvalue.conditions[key].actions.add_tags.tags[val]).length==0){ 
        //         console.log("empty",postvalue.conditions[key])
        //       }
        //     })
        // }


        if (this.alertvarservice.autoInvestigate.valid) {

          if (key === "0") {
            if (postvalue.conditions[key] && postvalue.conditions[key].actions) {
              postvalue.conditions[key].actions["condition"] = "if"
              //console.log("PostValue",postvalue)
            }
          }
          else if (key === String(postvalue.conditions.length - 1)) {
            if (postvalue.conditions[key].actions) {
              postvalue.conditions[key].actions["condition"] = "else"
            }
            else {
              postvalue.conditions.splice(postvalue.conditions.length - 1, 1)
            }
          }
          else if (postvalue.conditions[key].actions) {
            postvalue.conditions[key].actions["condition"] = "else_if"
          }
        }
        else {
          this.alertvarservice.showActionError = true
        }
      })

      // console.log("Edited time",this.timezoneservice.toUtcTimeZonefromUser(this.valid_date.value).format('YYYY-MM-DD HH:mm:ss'))
      // console.log("Engine Change --->",this.engineCheck(postvalue))
      this.children.forEach(data=>{
        // console.log(data)
        this.querytokensprovider.parseTokens(data.editor,'alert')
//console.log(this.querytokensprovider.getUniqueFields())
        this.querytokensprovider.getUniqueFields().forEach(val=>{
//console.log('Unique Fields')
//console.log({val})
          this.unique.add(val)
        })
//console.log(this.unique)
    })

      if (this.alertvarservice.editState) {

        if (this.alertvarservice.editrequested.value.activate_rule != this.activate.value) {
          this.alertvarservice.status_change = true
        }else{
          this.alertvarservice.status_change = false
        }

        // postvalue["platform"] = this.ruleCOnditions.platform
        postvalue["name"] = this.ruleCOnditions.name
        postvalue["type"] = this.ruleCOnditions.type
        postvalue["ruleFor"] = this.ruleCOnditions.ruleFor
        postvalue["description"] = this.ruleName.value
        postvalue["status"] = this.postSatusChange(this.activate.value)
        // postvalue["enginechange"] = this.engineCheck(postvalue)
        postvalue["ruleId"] = this.ruleCOnditions?.ruleId
        // postvalue["activate_rule"]=this.ruleCOnditions.activate_rule
        postvalue["activate_rule"] = this.activate.value
        postvalue["retroactive"] = this.retroactive.value
        // postvalue["retroactive"]=this.ruleCOnditions.retroactive
        postvalue["status_change"] = this.alertvarservice.status_change
        postvalue["timeframe"] = this.timeframe.value
        postvalue["stepsize"] = this.stepsize.value

        Object.assign(newPostValue,{ 
          ruleId:this.alertvarservice.editrequested.value?.ruleId,
          ruleFor: this.alertId, 
          description: this.ruleName.value ? this.ruleName.value : '', 
          // platform: this.alertvarservice.editrequested.value.platform, 
          type: this.alertvarservice.editrequested.value.type, 
          name: this.alertName, 
          status: this.postSatusChange(this.activate.value), 
          enginechange: this.engineCheck(newPostValue), 
          activate_rule: this.activate.value, 
          retroactive: this.retroactive.value, 
          status_change: this.alertvarservice.status_change, 
          timeframe: this.timeframe.value, 
          stepsize: this.stepsize.value ,
          retro_period:this.retroactive.value? this.retro_period.value :0,
          valid_for:this.will_expire.value ? this.valid_for.value :null,
          valid_type:this.will_expire.value ? this.valid_type.value :"",
          will_expire:this.will_expire.value,
          valid_date:this.will_expire.value ? this.valid_date.value : null,
          valid_till_date:this.will_expire.value ? this.timezoneservice.toUtcTimeZonefromUser(this.valid_date.value).format('YYYY-MM-DD HH:mm:ss'):null,
          rule_fields:Array.from(this.unique)

        })

        // console.log("Engine Change Check------->",this.engineCheck(postvalue))


      }
      else {
        Object.assign(postvalue,{ ruleFor: this.alertId, description: this.ruleName.value? this.ruleName.value : '',
          //  platform: this.platform, 
           type: this.ruleType, name: this.alertName, status: this.postSatusChange(this.activate.value), enginechange: true, activate_rule: this.alertvarservice.ruleForm.value.context.activate, retroactive: this.alertvarservice.ruleForm.value.context.retroactive, status_change: this.alertvarservice.status_change, timeframe: this.timeframe.value, stepsize: this.stepsize.value ,retro_period:this.retro_period.value,valid_for:this.valid_for.value,valid_type:this.valid_type.value,will_expire:this.will_expire.value,valid_date:this.valid_date.value,valid_till_date: this.valid_date.value ? this.timezoneservice.toUtcTimeZonefromUser(this.valid_date.value).format('YYYY-MM-DD HH:mm:ss') : ""

        });
        Object.assign(newPostValue,{ 
          ruleFor: this.alertId, 
          description: this.ruleName.value ? this.ruleName.value : '', 
          // platform: this.platform, 
          type: this.ruleType, 
          name: this.alertName, 
          status: this.postSatusChange(this.activate.value), 
          enginechange: true, 
          activate_rule: this.activate.value, 
          retroactive: this.retroactive.value, 
          status_change: this.alertvarservice.status_change, 
          timeframe: this.timeframe.value, 
          stepsize: this.stepsize.value ,
          retro_period:this.retroactive.value? this.retro_period.value :0,
          valid_for:this.will_expire.value ? this.valid_for.value :null,
          valid_type:this.will_expire.value ? this.valid_type.value :"",
          will_expire:this.will_expire.value,
          valid_date:this.will_expire.value ? this.valid_date.value : null,
          valid_till_date:this.will_expire.value ? this.timezoneservice.toUtcTimeZonefromUser(this.valid_date.value).format('YYYY-MM-DD HH:mm:ss'):null,
          rule_fields:Array.from(this.unique)

        });
      }
      // if(postvalue?.conditions.length<2){
      // console.log("size less than 2",postvalue)
      // postvalue.conditions.push(this.alertvarservice.defaultElse)

      // }

      Object.keys(this.alertvarservice.autoInvestigate.getRawValue().conditions).forEach(key => {
        if (this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions) {
          if (this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions == "") {
            //console.log("Inside Nested If")
            postvalue.conditions.splice(parseInt(key), 1)
            postvalue.conditions.push(this.alertvarservice.defaultElseIf)
          }
        }
        else {
          //console.log("Inside Else")
          postvalue.conditions.splice(parseInt(key), 1)
          postvalue.conditions.push(this.alertvarservice.defaultElse)

        }
      })

      // postvalue["ruleFor"]=this.alertId
      // postvalue["description"]=this.description
      // postvalue["platform"]=this.platform
      // postvalue["type"]=this.ruleType
      // postvalue["name"]=this.alertName
      // postvalue["status"]=1
      // postvalue["enginechange"]=false
      //console.log("PostValue",postvalue)
      //console.log("RawValue",this.alertvarservice.autoInvestigate.getRawValue())

      Object.keys(postvalue.conditions).forEach(key => {
        if (postvalue.conditions[key].actions?.condition != "else") {
          //console.log("not on else",postvalue.conditions[key])
          if (postvalue.conditions[key].actions?.action != "no_action_required") {
            //console.log("Not on No Action Required",postvalue.conditions[key])
            if (postvalue.conditions[key].actions?.state) {
              this.alertvarservice.actionEmpty = false
              this.alertvarservice.showActionError = false
              //console.log("Not Empty")
            }
            else {
              this.alertvarservice.actionEmpty = true
              this.alertvarservice.showActionError = true
              //console.log("Is Empty")
              if (this.alertvarservice.ActionErrorText.length > 0) {
                this.alertvarservice.ActionErrorText = ",", [key]
              }
              else {
                this.alertvarservice.ActionErrorText = key
              }
            }
          }
          else {
            this.alertvarservice.actionEmpty = false
            this.alertvarservice.showActionError = false
          }
        }

      })
      // Object.keys(this.alertvarservice.autoInvestigate.getRawValue().conditions).forEach(key=>{
      //   if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].condition === "else"){
      //     if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].query === ""){
      //       this.conditions.get(key.toString()).patchValue(this,this.alertvarservice.defaultElse)
      //     }
      //   }
      // })

      Object.keys(postvalue.conditions).forEach(key => {
        if (postvalue.conditions[key].actions.condition === "else") {
          if (postvalue.conditions[key].actions.query === "") {
            postvalue.conditions[key].actions.tokens.SearchCommand = []
            //console.log("^^^^^^^^^^^^^^^^^^Else",postvalue.conditions[key].actions)
          }
        }
      })

      // console.log("PostValue12",postvalue)
//console.log("newPostValue->",newPostValue)

      let valid=true

      Object.keys(this.ruleCOnditions.conditions).forEach(key=>{
//console.log(key,"->",this.ruleCOnditions.conditions[key])
        if(this.ruleCOnditions.conditions[key].actions.isValid ===false){
          valid=false
        }
      })

// <------------ New Post --------------->

    if(valid){
//console.log("<-----------------PostAlert---------------->")
//console.log(newPostValue)
//console.log(this.alertvarservice.editState)
      if (this.alertvarservice.editState) {
//console.log("Edit State")
        await this.alertservice.posteditrule.postrequest(newPostValue)
          .then((dat: any) => {
//console.log(dat)
            this.mat_spinner_create_state = false;
            if (dat) {
//console.log("if Dat>>>>>>>>>>>")
              this.open_toaster("Rule saved successfully", 'success');
              this.alertservice.providealertdata.emitstate = -1;
              this.cancelClick()
            } else {
//console.log("else Dat>>>>>>>>>>>>")
              this.open_toaster("Rule cannot be saved", 'failure');
            }
          })
          .catch(error => {
//console.log("Catch error>>>>>>>>>>>>",error)
            this.mat_spinner_create_state = false;
            this.open_toaster("Rule cannot be saved", 'failure')
          })
      }
      else {
        await this.alertservice.postnewrule.postrequest(newPostValue)
          .then((dat: any) => {
            //console.log(dat)
            this.mat_spinner_create_state = false;
            if (dat) {
              //console.log("if Dat>>>>>>>>>>>")
              this.open_toaster("Rule saved successfully", 'success');
              this.alertservice.providealertdata.emitstate = -1;
              this.cancelClick()
            } else {
              //console.log("else Dat>>>>>>>>>>>>")
              this.open_toaster("Rule cannot be saved", 'failure');
            }
            this.cancelClick();
          })
          .catch(error => {
            //console.log("Catch error>>>>>>>>>>>>",error)
            this.mat_spinner_create_state = false;
            this.open_toaster("Rule cannot be saved", 'failure')
          })
      }
    }


      //Post (UNUSED)
      if (this.alertvarservice.actionEmpty) {
        // this.alertvarservice.showError=true
        this.alertvarservice.showActionError = true
        //console.log("Query Not Verified")
      } else {
        if (this.alertvarservice.autoInvestigate.valid) {


          // if (this.alertvarservice.editState) {
          //   await this.alertservice.posteditrule.postrequest(newPostValue)
          //     .then((dat: any) => {
          //       //console.log(dat)
          //       this.mat_spinner_create_state = false;
          //       if (dat) {
          //         //console.log("if Dat>>>>>>>>>>>")
          //         this.open_toaster("success", 'success');
          //         this.alertservice.providealertdata.emitstate = -1;
          //         this.cancelClick()
          //       } else {
          //         //console.log("else Dat>>>>>>>>>>>>")
          //         this.open_toaster("Failed", 'failure');
          //       }
          //     })
          //     .catch(error => {
          //       //console.log("Catch error>>>>>>>>>>>>",error)
          //       this.mat_spinner_create_state = false;
          //       this.open_toaster("Failed", 'failure')
          //     })
          // }
          // else {
          //   await this.alertservice.postnewrule.postrequest(newPostValue)
          //     .then((dat: any) => {
          //       //console.log(dat)
          //       this.mat_spinner_create_state = false;
          //       if (dat) {
          //         //console.log("if Dat>>>>>>>>>>>")
          //         this.open_toaster("success", 'success');
          //         this.alertservice.providealertdata.emitstate = -1;
          //         this.cancelClick()
          //       } else {
          //         //console.log("else Dat>>>>>>>>>>>>")
          //         this.open_toaster("Failed", 'failure');
          //       }
          //       this.cancelClick();
          //     })
          //     .catch(error => {
          //       //console.log("Catch error>>>>>>>>>>>>",error)
          //       this.mat_spinner_create_state = false;
          //       this.open_toaster("Failed", 'failure')
          //     })
          // }
        }
        else {
          this.alertvarservice.showActionError = true
        }


      }
    }









    // postvalue['add_tags']=postvalue.conditions
    // console.log(this.alertvarservice.autoInvestigate.getRawValue())
    // console.log("RuleEditor",this.alertvarservice.ruleConditionEditor)
    // console.log("Engine Query",this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.alertvarservice.ruleConditionEditor).searchTokens))
  }
  open_toaster(msg: string, type: any) {
    this.toasterService.show({
      text: msg,
      type: type
    })
  }

  ngOnDestroy() {
//console.log("Auto Closure Destroyed")
    this.selectedIndex = 0
    this.current_index=0
    this.previous_index=0
    this.will_expire.setValue(false)
    this.ruleCOnditions.condition={}
    this.alertvarservice.autoClosureRuleCondition=JSON.parse(JSON.stringify(this.alertvarservice.defaultAutoClosureRuleCondition))
    this.alertvarservice.ruleselectedIndex=0
    this.alertvarservice.timeError = false
    this.alertvarservice.status_change = false
    this.alertvarservice.editState = false
    this.alertvarservice.editrequested.state = false
    // this.ruleCOnditions = null
    this.alertvarservice.queryVerified = false
    this.alertvarservice.postError = true
    this.alertvarservice.showError = false
    this.alertvarservice.showActionError = false
    // this.alertvarservice.resetAutoInvestigate()
    this.alertvarservice.autoInvestigate = this.alertvarservice.defaultAutoInvestigate
    //console.log(this.alertvarservice.autoInvestigate)
    this.alertvarservice.resetRuleForm()
    this.alertvarservice.resetAutoClosure()
    this.alertvarservice.actionWindow = ''
    this.alertvarservice.stateWindow = ''
    // this.alertvarservice.resetAutoInvestigate()
    this.alertvarservice.autoInvestigate = this.alertvarservice.defaultAutoInvestigate
    // this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor, '')
    this.$destroy.next(true);
    this.rcrumpService.route_crumps.length = 2;
    this.alertvarservice.closureAction1 = {}

  }



  // addCond(i:number){
  //   let newcond={"cond":"else_if","index":i+1,"optional":false,"value":{}}
  //   this.alertvarservice.autoInvList.splice(i+1,0,newcond)
  // this.alertvarservice.addFilterCondition(i)

  // }
  // removeCond(cond:any){
  //   console.log("Condition",cond)

  // }

  moveUp() {
    if (this.selectedIndex > 0) {
      moveItemInArray(this.ruleCOnditions.conditions, this.selectedIndex, this.selectedIndex - 1);
      this.conditionClick(this.selectedIndex - 1)
    }

  }
  moveDown() {
    if (this.selectedIndex + 1 < this.ruleCOnditions.conditions.length) {
      moveItemInArray(this.ruleCOnditions.conditions, this.selectedIndex, this.selectedIndex + 1);
      this.conditionClick(this.selectedIndex + 1)
    }
  }
  drop(event: CdkDragDrop<[]>) {
    moveItemInArray(this.ruleCOnditions.conditions, event.previousIndex, event.currentIndex);
    this.conditionClick(event.currentIndex)
  }

  async setLanguageGrammar(platform: string, alertId: string) {
    this.mat_spinner_create_state=true
    // console.log("Start =----> ",this.mat_spinner_create_state)
    await this.sharedService.getruleLanguageGrammar(platform, alertId)
      .then((platform_plugins: object) => {
        
//console.log({platform_plugins})
        this.queryEditorService.processFields([])
        // this.queryEditorService.setExternalTokens(platform_plugins['external_tokens'], platform_plugins['suggestion_rules'], platform_plugins['tokens_map_json'], platform_plugins['platform_fields'])
        this.platform_plugins = platform_plugins
        // this.createeditor(this.builtInquery, platform_plugins['grammar']);
        this.mat_spinner_create_state=false
        // console.log("End =----> ",this.mat_spinner_create_state)

      })
      .catch((err) => { console.log(err) ;this.mat_spinner_create_state=false})
  }
  nextPage() {
    if(this.alertvarservice.ruleselectedIndex == 0){
      if(!this.alertvarservice.errorState[1]){
        this.alertvarservice.ruleselectedIndex = this.alertvarservice.ruleselectedIndex + 1
      }
    }else{
       this.alertvarservice.ruleselectedIndex = this.alertvarservice.ruleselectedIndex + 1
    }
    
  }
  previousPage() {
    this.alertvarservice.ruleselectedIndex = this.alertvarservice.ruleselectedIndex - 1
  }
  changeTab(event) {
    this.alertvarservice.ruleselectedIndex = event

  }
}

